/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * Debt Servicing Uploader State
 *
 * @type {Object}
 */
const state = {
    error: false,
    loading: false,
    activeStep: 'pnl',
    showModal: false,
    context: null,
    success: false,
    showInput: true,
    pnl: {
        data: {
            date: null,
            file_name: null,
            income: [],
            income_category_list: [],
            meta: {},
            opex: [],
            opex_category_list: []
        }
    },
    rentroll: {},
    reports: {
        file_uploads: []
    }
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/uploader/state.js